import { Component, OnInit } from '@angular/core';
import { CargaAbonosService } from 'src/app/services/carga-abonos/carga-abonos.service';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { DialogPagoCuota } from 'src/app/components/afiliacion/cuota-pago.component';
import { DialogMostrarPagoAfiliado } from 'src/app/components/afiliacion/afiliado-mostrar-pago.component';

import { DialogAnularReversarCuota } from 'src/app/components/afiliacion/cuota-pago-anular.component';
import { ConvenioAbonoService } from 'src/app/services/convenio-abono/convenio-abono.service';
import { isNullOrUndefined } from 'util';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';
import { NgForm } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';


export interface DialogData {
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare const Rut: any;

@Component({
    selector: 'app-cuotas-pagadas',
    templateUrl: '../../pages/afiliacion/cuotas-pagadas/cuotas-pagadas.component.html',
    styleUrls: ['../../pages/afiliacion/cuotas-pagadas/cuotas-pagadas.component.css']
})
export class CuotasPagadasComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    idUsuario: string = localStorage.getItem("idUsuario")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    cargaMasiva: any = { tipoCarga: null, idUsuario: null, archivo: File = null, }
    currentDate: any
    botonActivo: any = true
    allComplete: boolean = false
    afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
    afiliadoCuota: any
    buscador: any =
        {
            selectConvenio: 0,
            rut: '', rut2: '', rutAfiliado: '', region: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
            estado: ['APROBADA']
        }

    constructor(private CargaAbonosService: CargaAbonosService,
        private afiliacionService: AfiliacionService,
        public convenioAbonoService: ConvenioAbonoService,
        private postulacionesService: PostulacionesService,
        private dialog: MatDialog) { }

    ngOnInit(): void {
        let vm = this
        this.currentDate = new Date(Date.now()).getTime();


        this.loadData()
    }

    loadData() {
        let vm = this
        if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
            vm.buscarCuotasPagadas(localStorage.getItem("idUsuario"));
        }

        if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {

            vm.afiliado.rut=localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
            vm.afiliado.nombreAfiliado=localStorage.getItem("nombreUsuario");
            vm.afiliado.idAfiliado=localStorage.getItem("idUsuario");
        }


    }


    verArchivo(postulacionId: any) {
        let vm = this

        this.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL);
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)

                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }


    csvInputChange(fileInputEvent: any) {

        this.cargaMasiva.archivo = fileInputEvent.target.files[0]
    }



    openEditDialogValidarConvenio() {

    }
    verPlanPago() {

    }
    buscaAfiliado(rutABuscar: any) {

        if (Rut(rutABuscar)) {
            let rut = rutABuscar.split('.').join('').split('-')[0]

            this.traePostulantes(rut);
            console.log("this.afiliado.idAfiliado ", this.afiliado.idAfiliado);


        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    traePostulantes(rut: any) {

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let vm = this
        this.convenioAbonoService.traePostulantes(rut).then
            (
                (usuario: Usuario) => {

                    vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
                    vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
                    vm.afiliado.idAfiliado = usuario.id
                    vm.buscarCuotasPagadas(vm.afiliado.idAfiliado);

                    Swal.close();

                }
            )
            .catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
            })
    }
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    // salir() { this.router.navigate(['/index']) }

    buscarCuotasPagadas(idUsuario: any) {
        let vm = this
        this.afiliacionService.traeCuotasPagadas(idUsuario).then(
            (pagos: any) => {
                vm.afiliadoCuota = pagos
                vm.buscador.paginasTotal = pagos.length
                vm.config.currentPage = this.buscador.currentPage
                vm.config.totalItems = pagos.cantidadRegistros
              
                Swal.close();
            }

        ).catch(error => console.log(error))
    }

    pagarDeuda(id: any) {
        let vm = this
        const indice = this.afiliadoCuota.findIndex(elemento => elemento.id === id);
        let existeVigente = false;
        for (let i = indice+1; i <= vm.buscador.paginasTotal; i++) { 
            if ((this.afiliadoCuota[i]) && this.afiliadoCuota[i].estado == 'VIGENTE') {
                existeVigente = true;
            }
        }

        if (existeVigente) {
            vm.openAlertDialog('No debe existir una cuota previa VIGENTE antes de pagar la actual', 'btn-danger')
            Swal.close();
            return false;
        }
        /*
        if ((this.afiliadoCuota[indice + 1]) && this.afiliadoCuota[indice + 1].estado == 'VIGENTE') {
            vm.openAlertDialog('No debe existir una cuota previa VIGENTE antes de pagar la actual', 'btn-danger')
            Swal.close();
            return false;
        }*/

        this.afiliacionService.traeCuotaAPagar(id).then(
            (response: any) => {
                let data: any =
                {

                    id: response.id,
                    nombreUsuario: response.nombreUsuario,
                    apellidoUsuario: response.setApPaternoUsuario,
                    rutUsuario: response.rutUsuario,
                    fechacuota: response.fechaCuota.split('-')[1] + "-" + response.fechaCuota.split('-')[2],
                    idCantidadCuota: response.idCantidadCuota,
                    monto: response.monto,
                    fechaIngreso: response.fechaIngreso,
                    fechaPrimerPago: response.fechaPrimerPago
                }
                let vm = this;

                const dialogRef = vm.dialog.open(DialogPagoCuota,
                    { width: '35%', height: '60%', data: data })
                Swal.close();
                dialogRef.afterClosed().subscribe(() => {
                  
                    this.buscarCuotasPagadas(vm.afiliado.idAfiliado)
                  
                })
            }
        )
            .catch(error => {
                console.log(error)
                Swal.close();
                this.openAlertDialog('No se pudo obtener la cuota a pagar.', 'btn-dark')
            })
    }

    detalleRechazoBeneficiario(id: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let data: any = { }

        this.afiliacionService.buscarPago(id).then
        (
            (postulacion: any) =>
            {
              
                data.tipoRechazo=postulacion.nombreMotivoRechazo
                data.comentarioRechazo=postulacion.motivoRechazo
             
            }
        )
        .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe( () => {  })
    }


    openDialogValidarPago(id: any) {
        this.afiliacionService.buscarPago(id).then(
          (response: any) => {
            let fechaPagoString =""
              let fechaCuotaRealString = response.fechaCuota.split('-')[2] + '-' + response.fechaCuota.split('-')[1] + '-' +
            response.fechaCuota.split('-')[0]    
           if(response.fechaPago){
              fechaPagoString = response.fechaPago.split('-')[2] + '-' + response.fechaPago.split('-')[1] + '-' +
              response.fechaPago.split('-')[0]
            } 
           
            let data: any =
            {
              id: response.id,
              rutUsuario: response.rut,
              nombreUsuario: response.nombreUsuario,
              idUsuario:response.usuarioId,
              monto: response.monto,
              fechaCuota: fechaCuotaRealString,
              fechaPago: fechaPagoString,
              fechaPagoIndicado: response.fechaCuota,
              mostrarEditar: false,
              disponiblePago: false,
              nombreMotivoRechazo: response.nombreMotivoRechazo,
              motivoRechazo: response.motivoRechazo,
              motivoAnulacion: response.motivoAnulacion,
              estado: response.estado
            }
            let vm = this;    
            const dialogRef = vm.dialog.open(DialogMostrarPagoAfiliado,
              { width: '40%', data: data })
            Swal.close();
          }
        ).catch(error => {
          console.log(error)
          Swal.close();
          this.openAlertDialog('Ha ocurrido un error para visualizar el pago.', 'btn-danger')
        })
      }
   
    anularCuota(idCuota: any) {
        let vm = this;
        let data: any = {
            idCuota: idCuota,
            motivoAnulacion: ''
        }
        const dialogRef = this.dialog.open(DialogAnularReversarCuota,
          { disableClose: true, width: '40%', data: data })
    
        dialogRef.afterClosed().subscribe(() => {
        this.buscarCuotasPagadas(this.afiliado.idAfiliado);
          if (data.recarga) vm.loadData();
        });
      }

    pageChanged(event: any, rutABuscar: any) {
        this.config.currentPage = event
        this.buscador.currentPage = event
        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
        let rut = rutABuscar.split('.').join('').split('-')[0]
        if (rut) {
            this.traePostulantes(rut);
        }
    }




}